var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAddNote = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_add_note",
  transform: "translate(-682 -508)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  transform: "translate(683 509)",
  fill: "#3f68b5",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "check-24px",
  transform: "translate(684.143 510.143)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M0,0H17.715V17.715H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1151",
  "data-name": "Group 1151",
  transform: "translate(-0.979 1.872)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M7.536,13.4l1.044,1.044,7.813-7.813L15.353,5.59Z",
  transform: "translate(-5.445 8.625) rotate(-45)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_387",
  "data-name": "Path 387",
  d: "M7.536,13.4l1.044,1.044,7.813-7.813L15.353,5.59Z",
  transform: "translate(8.721 -8.296) rotate(45)",
  fill: "#fff"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_add_note.b2c6fabae8d57c4f2af96e7a03140d8a.svg";